/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";
//import { useService } from "@web/core/utils/hooks";
import {IsTomSelect} from "@wpc_portal/components/tom_select/tom_select";

export class WPCPortalStudentClassList extends Component {
    static template = 'wpc_portal.student_class_list'
    static components = {
        IsTomSelect,
    }
    static defaultProps = {
        schoolId: '',
    }
    setup() {
        var self = this;
        self.modalAddExternalClassRef = useRef('modalAddExternalClassRef');
        var state = useState({
            school_name_search: '',
            selectedExtraSchoolId: '',
            extra_class_list: [],
            extra_class_list_loading: false,
            isSaving: false,
            loading: false,
        })
        self.state = state;

        useEffect(()=>{
            self.get_class_list();
        }, ()=>[
            self.props.schoolId,
        ])

        useEffect((selectedExtraSchoolId)=>{
            self.get_extra_class_list(selectedExtraSchoolId);
        }, ()=>[
            self.state.selectedExtraSchoolId,
        ])

//        useEffect(()=>{
//            self.get_school_list(self.state.school_name_search);
//        }, ()=>[
//            self.state.school_name_search,
//        ])
    }

    get_class_list(skip_update_loading) {
        if (!this.props.schoolId){
            return;
        }
        var self = this;
        if (!skip_update_loading){
            self.state.loading = true;
        }
        return $.getJSON({url: `/api/student/class_list?school_id=${self.props.schoolId}`}).then(data=>{
            self.props.state.class_list = data;
            if (!skip_update_loading) {
                self.state.loading = false;
            }
        });
    }

    get_extra_class_list(selectedExtraSchoolId){
        if (!selectedExtraSchoolId){
            return;
        }
        var self = this;
        self.state.extra_class_list_loading = true;
        return $.getJSON({url: `/api/student/class_list?extra_school=1&school_id=${selectedExtraSchoolId}`}).then(data=>{
           // debugger;
            self.state.extra_class_list = data.map(o=>{ return {...o, selected: false}});
            self.state.extra_class_list_loading = false;
        });
    }

//    get_school_list(search){
//        var self = this;
//        return $.getJSON({url: '/api/student/school_list?search=' + search}).then(data=>{
//            self.props.state.school_list = data;
//        });
//    }

    getSchoolListItems(query, callback){
        var self = this;
        return $.getJSON({url: '/api/student/school_list?search=' + query}).then(data=>{
            console.log('ITEMS', data);
            callback(data || []);
            callback([]);
        }).catch(()=>{
            callback([]);
        });
    }

    addExternalClass() {
        var self = this;
        this.state.isSaving = true;
        $.ajax({url: '/api/student/extra_classes', dataType: 'json', type:'POST', data: window.JSON.stringify({
            selected_classes_ids: this.state.extra_class_list.filter(o=>o.selected).map(o=>o.id),
        })}).then((res)=>{
            return this.get_class_list(true);
        }).then((res)=>{
            $(self.modalAddExternalClassRef.el).modal('hide');
            self.state.isSaving = false;
        }).catch((err)=>{
            alert(err);
            this.state.isSaving = false;
        })
    }
}
